export default {
  filterByStars: {
    id: 'reviews_rate_filter_title',
    defaultMessage: 'Filter by stars',
  },
  all: {
    id: 'reviews_rate_filter_all',
    defaultMessage: 'All',
  },
  fourFive: {
    id: 'reviews_rate_filter_between_4_and_5',
    defaultMessage: '4-5 stars',
  },
  threeFour: {
    id: 'reviews_rate_filter_between_3_and_4',
    defaultMessage: '3-4 stars',
  },
  twoThree: {
    id: 'reviews_rate_filter_between_2_and_3',
    defaultMessage: '2-3 stars',
  },
  oneTwo: {
    id: 'reviews_rate_filter_between_1_and_2',
    defaultMessage: '1-2 stars',
  },
  percentage: {
    id: 'reviews_rate_filter_percentage',
    defaultMessage: '{ percentage }%',
  },
  filterReviewsParametersTitle: {
    id: 'reviews_parameter_selectors_title',
    defaultMessage: 'Only reviews',
  },
  filterReviewsCurrentSeller: {
    id: 'reviews_parameter_selectors_current_seller',
    defaultMessage: 'From current seller',
  },
  filterReviewsCurrentSellerTooltipTitle: {
    id: 'reviews_parameter_selectors_current_seller_tooltip_title',
    defaultMessage: 'What does this mean?',
  },
  filterReviewsCurrentSellerTooltipText: {
    id: 'reviews_parameter_selectors_current_seller_tooltip_text',
    defaultMessage:
      'Since our marketplace is ever-changing, the seller for this item can vary',
  },
  filterReviewsWithPictures: {
    id: 'reviews_parameter_selectors_with_pictures',
    defaultMessage: 'With customer pictures',
  },
  filterReviewsCurrentCountry: {
    id: 'reviews_parameter_selectors_current_country',
    defaultMessage: 'From {country}',
  },
  filterByGrade: {
    id: 'reviews_grade_filter_title',
    defaultMessage: 'Filter by grade',
  },
  filterByGradePremium: {
    id: 'reviews_grade_filter_premium',
    defaultMessage: 'Premium',
  },
  filterByGradeFlawless: {
    id: 'reviews_grade_filter_excellent',
    defaultMessage: 'Excellent',
  },
  filterByGradeGood: {
    id: 'reviews_grade_filter_good',
    defaultMessage: 'Good',
  },
  filterByGradeFair: {
    id: 'reviews_grade_filter_fair',
    defaultMessage: 'Fair',
  },
  mobileFiltersTitle: {
    id: 'reviews_mobile_filters_title',
    defaultMessage: 'Filters',
  },
  mobileFiltersClose: {
    id: 'reviews_mobile_filters_close',
    defaultMessage: 'Close',
  },
  applyFilters: {
    id: 'reviews_mobile_filters_apply',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'reviews_mobile_filters_reset',
    defaultMessage: 'Reset filters',
  },
}
